// src/services/ai/providers/AIProvider.js
// Base class for AI providers

export default class AIProvider {
  constructor(config = {}) {
    this.config = config;
  }

  /**
   * Send a chat message to the AI provider
   * @param {Array} messages - Array of { role: 'user'|'assistant'|'system', content: string }
   * @param {Array} tools - Array of tool definitions
   * @returns {Promise<{ content: string, toolCalls: Array|null }>}
   */
  async chat(messages, tools = []) {
    throw new Error('chat() must be implemented by subclass');
  }

  /**
   * Get the provider name
   * @returns {string}
   */
  getName() {
    throw new Error('getName() must be implemented by subclass');
  }
}
